import { DarkPaymentCardClient } from "./DarkPaymentCardClient";

type DarkPaymentCardProps = {
  card: PaymentCard;
};

export function DarkPaymentCard({ card }: DarkPaymentCardProps) {
  return <DarkPaymentCardClient card={card} />;
}
